import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import orderFilterSlice from "../features/api/order/orderFilterSlice";
import productsSlice from "../features/api/products/productsSlice";
import commonFilterSlice from "../features/filter/commonFilterSlice";
import capitalFilterSlice from "../features/filter/capitalFilterSlice";
import { checkPriceAndStockMiddleWare } from "../features/api/middleware/checkPriceAndStockMiddleWare";
import spendingFilterSlice from "../features/filter/spendingFilterSlice";
import userSlice from "../features/api/user/userSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
    products: productsSlice,
    orderFilter: orderFilterSlice,
    commonFilter: commonFilterSlice,
    capitalFilter: capitalFilterSlice,
    spendingFilter: spendingFilterSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(
      apiSlice.middleware
      // checkPriceAndStockMiddleWare
    ),
});

let previousUser = store.getState().user.info;

store.subscribe(() => {
  const state = store.getState();
  const currentUser = state.user.info;

  // Check if user has changed
  if (currentUser !== previousUser) {
    localStorage.setItem(
      "supplyCornerBackOfficeUser",
      JSON.stringify(currentUser)
    );

    // Clone the object to avoid reference issues
    previousUser = currentUser;
  }
});
